import gsap from 'gsap';
import Component from '../app/component';
import media from '../helpers/media';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {};
  }

  init() {
    this.skySet();

    if (media.test('until-large')) {
      // media.watch('portrait', () => this.skySet())
      return;
    }
    
    this.tween1a = this.tweenSprite1a();
    this.tween1b = this.tweenSprite1b();
    this.tween1c = this.tweenSprite1c();
    this.tween2a = this.tweenSprite2a();
    this.tween2b = this.tweenSprite2b();
    this.tween3a = this.tweenSprite3a();
    this.tween3b = this.tweenSprite3b();
    this.tween4a = this.tweenSprite4a();
    this.tween4b = this.tweenSprite4b();
    this.tween5a = this.tweenSprite5a();
    this.tween6a = this.tweenSprite6a();
    this.tween6b = this.tweenSprite6b();
    this.tween7a = this.tweenSprite7a();
    this.tween7b = this.tweenSprite7b();
    this.tween8a = this.tweenSprite8a();
    this.tween9a = this.tweenSprite9a();
    this.tween10a = this.tweenSprite10a();
    this.tween11a = this.tweenSprite11a();

    this.setListeners();

    this.tween1b.pause()
    this.tween1c.pause()
    this.tween2b.pause()
    this.tween3b.pause()
    this.tween4b.pause()
    this.tween6b.pause()
    this.tween7b.pause()
  }

  setListeners() {
    this.refs.overlay1.addEventListener('mouseenter', () => {
      this.refs.sprite1a.classList.add('island-overlay-sprite--hidden');
      this.refs.sprite1c.classList.remove('island-overlay-sprite--hidden');
      this.tween1b.play()
      this.tween1c.restart()
      this.tween1c.play()
    })
    this.refs.overlay1.addEventListener('mouseleave', () => {
      this.refs.sprite1a.classList.remove('island-overlay-sprite--hidden');
      this.refs.sprite1c.classList.add('island-overlay-sprite--hidden');
      this.tween1b.play()
      this.tween1b.reverse()
    })

    this.refs.overlay2.addEventListener('mouseenter', () => {
      this.tween2b.restart()
      this.tween2b.play()
    })
    this.refs.overlay2.addEventListener('mouseleave', () => {
      this.tween2b.restart()
      this.tween2b.pause()
    })

    this.refs.overlay3.addEventListener('mouseenter', () => {
      this.tween3b.restart()
      this.tween3b.play()
    })
    this.refs.overlay3.addEventListener('mouseleave', () => {
      this.tween3b.restart()
      this.tween3b.pause()
    })

    this.refs.overlay4.addEventListener('mouseenter', () => {
      this.tween4b.restart()
      this.tween4b.play()
    })
    this.refs.overlay4.addEventListener('mouseleave', () => {
      this.tween4b.restart()
      this.tween4b.pause()
    })
    
    this.refs.overlay5.addEventListener('mouseenter', () => {
      this.refs.sprite5a.classList.add('island-overlay-sprite--hidden')
      this.refs.sprite5b.classList.remove('island-overlay-sprite--hidden')
    })
    this.refs.overlay5.addEventListener('mouseleave', () => {
      this.refs.sprite5a.classList.remove('island-overlay-sprite--hidden')
      this.refs.sprite5b.classList.add('island-overlay-sprite--hidden')
    })

    this.refs.overlay6.addEventListener('mouseenter', () => {
      this.tween6b.restart()
      this.tween6b.play()
    })
    this.refs.overlay6.addEventListener('mouseleave', () => {
      this.tween6b.restart()
      this.tween6b.pause()
    })
    
    this.refs.overlay7.addEventListener('mouseenter', () => {
      this.tween7b.restart()
      this.tween7b.play()
      this.refs.sprite7a.classList.add('island-overlay-sprite--hidden');
      this.refs.sprite7b.classList.remove('island-overlay-sprite--hidden');
    })
    this.refs.overlay7.addEventListener('mouseleave', () => {
      this.tween7b.restart()
      this.tween7b.pause()
      this.refs.sprite7a.classList.remove('island-overlay-sprite--hidden');
      this.refs.sprite7b.classList.add('island-overlay-sprite--hidden');
    })
  }

  skySet() {
    if (!this.refs.sky) {
      return;
    }
    const hours = new Date().getHours();
    
    ;[1, 2, 3, 4].forEach((i) => {
      this.refs.sky.classList.remove(`island--sky${i}`);
    });

    this.el.classList.add(`island--hours${hours}`)

    if (hours >= 5 && hours < 9) {
      this.el.classList.add('island--sky1');
      if (media.test('until-large') && this.refs.mobileImage) {
        this.refs.mobileImage.src = '/assets/img/island-mobile-portrait-1.png'
      }
    } else if(hours >= 9 && hours < 17) {
      this.el.classList.add('island--sky2');
      if (media.test('until-large') && this.refs.mobileImage) {
        this.refs.mobileImage.src = '/assets/img/island-mobile-portrait-2.png'
      }
    } else if(hours >= 17 && hours < 20) {
      this.el.classList.add('island--sky3');
      if (media.test('until-large') && this.refs.mobileImage) {
        this.refs.mobileImage.src = '/assets/img/island-mobile-portrait-3.png'
      }
    } else {
      this.el.classList.add('island--sky4');
      if (media.test('until-large') && this.refs.mobileImage) {
        this.refs.mobileImage.src = '/assets/img/island-mobile-portrait-4.png'
      }
    }
  }

  tweenSprite1a() {
    return gsap.to(
      this.refs.sprite1a,
      {
        xPercent: -90,
        z: 0,
        duration: 0.9,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(9)'
      },
      0
    );
  }

  tweenSprite1b() {
    return gsap.to(
      this.refs.sprite1b,
      {
        xPercent: -91.666666,
        z: 0,
        duration: 0.9,
        ease: 'steps(11)'
      },
      0
    );
  }

  tweenSprite1c() {
    return gsap.to(
      this.refs.sprite1c,
      {
        xPercent: -91.666666,
        z: 0,
        duration: 0.9,
        ease: 'steps(11)'
      },
      0
    );
  }

  tweenSprite2a() {
    return gsap.to(
      this.refs.sprite2a,
      {
        xPercent: -75,
        z: 0,
        duration: 0.5,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(3)'
      },
      0
    );
  }

  tweenSprite2b() {
    return gsap.to(
      this.refs.sprite2b,
      {
        xPercent: -85.714285714285714,
        z: 0,
        duration: 0.9,
        ease: 'steps(6)'
      },
      0
    );
  }

  tweenSprite3a() {
    return gsap.to(
      this.refs.sprite3a,
      {
        xPercent: -83.333333,
        z: 0,
        duration: 0.7,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(5)'
      },
      0
    );
  }

  tweenSprite3b() {
    return gsap.to(
      this.refs.sprite3b,
      {
        xPercent: -94.4444,
        z: 0,
        duration: 2,
        ease: 'steps(17)'
      },
      0
    );
  }

  tweenSprite4a() {
    return gsap.to(
      this.refs.sprite4a,
      {
        xPercent: -75,
        z: 0,
        duration: 0.5,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(3)'
      },
      0
    );
  }

  tweenSprite4b() {
    return gsap.to(
      this.refs.sprite4b,
      {
        xPercent: -91.666666,
        z: 0,
        duration: 0.7,
        ease: 'steps(11)'
      },
      0
    );
  }

  tweenSprite5a() {
    return gsap.to(
      this.refs.sprite5a,
      {
        xPercent: -83.333333,
        z: 0,
        duration: 0.5,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(5)'
      },
      0
    );
  }

  tweenSprite6a() {
    return gsap.to(
      this.refs.sprite6a,
      {
        xPercent: -83.333333,
        z: 0,
        duration: 0.5,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(5)'
      },
      0
    );
  }

  tweenSprite6b() {
    return gsap.to(
      this.refs.sprite6b,
      {
        xPercent: -91.66666666666667,
        z: 0,
        duration: 1,
        repeatDelay: 0,
        ease: 'steps(11)'
      },
      0
    );
  }

  tweenSprite7a() {
    return gsap.to(
      this.refs.sprite7a,
      {
        xPercent: -87.5,
        z: 0,
        duration: 0.7,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(7)'
      },
      0
    );
  }

  tweenSprite7b() {
    return gsap.to(
      this.refs.sprite7b,
      {
        xPercent: -88.88888888888889,
        z: 0,
        duration: 1,
        repeatDelay: 0,
        ease: 'steps(8)'
      },
      0
    );
  }

  tweenSprite8a() {
    return gsap.to(
      this.refs.sprite8a,
      {
        xPercent: -83.333333333333333,
        z: 0,
        duration: 0.7,
        repeatDelay: 0,
        ease: 'steps(5)',
        yoyo: false,
        repeat: -1
      },
      0
    );
  }

  tweenSprite9a() {
    return gsap.to(
      this.refs.sprite9a,
      {
        xPercent: -87.5,
        z: 0,
        duration: 1.8,
        yoyo: false,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(7)'
      },
      0
    );
  }
  
  tweenSprite10a() {
    return gsap.to(
      this.refs.sprite10a,
      {
        xPercent: -87.5,
        z: 0,
        duration: 1.8,
        yoyo: false,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(7)'
      },
      0
    );
  }
  
  tweenSprite11a() {
    return gsap.to(
      this.refs.sprite11a,
      {
        xPercent: -87.5,
        z: 0,
        duration: 1.8,
        yoyo: false,
        repeat: -1,
        repeatDelay: 0,
        ease: 'steps(7)'
      },
      0
    );
  }
}
